import type { BuildLeafFieldInput, GeneratedSchemaField } from '@cli-types/core-engine/add-field.js'
import type { FormField, SchemaField } from '@cli-types/core-engine/schema.js'
import { validateGeneratedFieldName } from './validate-generated-field-name.js'
import { validateLeafFieldInput } from './validate-leaf-field-input.js'

export function buildLeafField(input: BuildLeafFieldInput): GeneratedSchemaField {
  const errors = [...validateGeneratedFieldName(input.name), ...validateLeafFieldInput(input)]

  if (errors.length > 0) {
    throw new Error(errors.join('\n'))
  }

  const field: Record<string, unknown> = {
    name: input.name,
    type: input.type,
    label: input.label
  }

  if (input.required) {
    field.required = true
  }

  if (input.kind === 'form') {
    if (input.multiple && input.type === 'file') {
      field.multiple = true
    }
    if (input.options && input.options.length > 0) {
      field.options = input.options
    }
    return field as unknown as FormField
  }

  if (input.multiple && ['select', 'relationship'].includes(input.type)) {
    field.multiple = true
  }

  if (input.creatable && input.type === 'select') {
    field.creatable = true
  }

  if (input.options && input.options.length > 0) {
    field.options = input.options
  }

  if (input.relationship && input.type === 'relationship') {
    field.relationship = input.relationship
  }

  return field as unknown as SchemaField
}
